import { HTMLAttributes, FC } from "react";
import clsx from "classnames";
import { useStyles } from "./Toggle.style";

interface IToggleProps {
  checked?: boolean;
  onChange?: (checked?: boolean) => void;
  disabled?: boolean;
}

export const Toggle: FC<IToggleProps & HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const classes = useStyles();
  const { checked, onChange, disabled, ...othersProps } = props;

  return (
    <span {...othersProps} className={clsx(classes.root, props.className)}>
      <input
        className={classes.tgl}
        type="checkbox"
        id={othersProps.id || "toggle-input"}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label
        className={clsx(
          classes.genButton,
          "tgl-btn",
          disabled && classes.disabled,
        )}
        htmlFor={othersProps.id || "toggle-input"}
      />
      <div className={clsx(classes.circle, checked && classes.checked)} />
    </span>
  );
};
